export const testingAccounts = {
  userAccount: {
    email: "user@user.com",
    password: "123456",
  },

  adminAccount: {
    email: "admin@admin.com",
    password: "123456",
  },

  restaurantAccount: {
    email: "restaurant@restaurant.com",
    password: "123456",
  },
};
